import styled from 'styled-components'

export const SidebarChatContainer = styled.div`
    display: flex;
    width:100%;
    flex-direction:column;
    overflow-x: auto;
    height: 100%;

`;